const Billing = () => {
  return (
    <>
      <div className="flex flex-col justify-between gap-4 mb-8 md:flex-row sm:gap-8">
        <div className="flex flex-col">
          <div className="text-3xl font-bold leading-6 text-neutral-800 sm:text-2xl">Interested in subscribing?</div>
          <div className="mt-2 font-normal leading-normal text-gray-500 text-md md:text-sm">
            Please reach out to us at contact@umbre.ai
          </div>
        </div>
      </div>
    </>
  );
};

export default Billing;
